<template>
  <svg
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="14.5" cy="14.5" r="14" stroke="#F9D849" />
    <path
      d="M11.6124 9.74413C11.685 9.67622 11.7712 9.62235 11.8661 9.58559C11.961 9.54883 12.0628 9.52991 12.1656 9.52991C12.2683 9.52991 12.3701 9.54883 12.465 9.58559C12.5599 9.62235 12.6461 9.67622 12.7187 9.74413L17.9124 14.5916C17.9704 14.6456 18.0163 14.7097 18.0477 14.7803C18.0791 14.8508 18.0952 14.9265 18.0952 15.0029C18.0952 15.0793 18.0791 15.1549 18.0477 15.2255C18.0163 15.2961 17.9704 15.3602 17.9124 15.4141L12.7187 20.2616C12.4124 20.5475 11.9187 20.5475 11.6124 20.2616C11.3062 19.9758 11.3062 19.515 11.6124 19.2291L16.1374 15L11.6062 10.7708C11.3062 10.4908 11.3062 10.0241 11.6124 9.74413Z"
      fill="#F9D849"
    />
  </svg>
</template>
